<template>
  <div>
    <div>
      <div v-if="loaded && companyPrograms.length === 0">
        <div class="alert alert-primary" role="alert">برنامه‌ای یافت نشد.</div>
      </div>
    </div>
    <div>
      <b-row align-v="center" align-h="between">
        <b-col sm="8" lg="4" align-self="center"
          ><b-form-input
            v-model="searchProgram"
            placeholder="جستجو برنامه بر اساس نام"
            class="mb-3"
            @keypress="notSpace($event)"
            @keydown.enter="searchPrograms"
          ></b-form-input
        ></b-col>
        <b-col align-v="center" align-h="between">
          <button
            type="button"
            class="btn btn-primary mb-3"
            title="جستجو"
            @click="searchPrograms"
            :disabled="!searchProgram"
          >
            <i class="fal fa-search pt-1" />
            جستجو
          </button></b-col
        >
        <b-col></b-col>
      </b-row>
    </div>
    <div
      v-if="loaded && companyPrograms.length"
      class="card card-custom gutter-b"
    >
      <div class="card-body">
        <div class="table-responsive">
          <table
            class="table table-head-custom table-head-bg table-borderless table-vertical-center"
          >
            <thead>
              <tr>
                <th>عنوان</th>
                <th>کاربر</th>
                <th>ارشیو</th>
                <th>پلن</th>
                <th>تاریخ</th>
                <th>عملیات</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="program in companyPrograms"
                :key="program.id"
                :class="{ 'bg-danger': isStopped(program) }"
              >
                <td class="text-nowrap">{{ program.name }}</td>
                <td class="text-nowrap">
                  <router-link
                    :to="{
                      name: 'company-users-show',
                      params: { id: program.user_id }
                    }"
                  >
                    {{ gFullName(program.user) }}
                  </router-link>
                </td>
                <td>{{ program.archive_status === 1 ? "بله" : "خیر" }}</td>
                <td>{{ programPlans[program.plan] }}</td>
                <td dir="ltr" class="text-nowrap">
                  {{ formatDate(program.created_at) }}
                </td>
                <td class="text-nowrap">
                  <router-link
                    :to="{
                      name: 'company-programs-show',
                      params: { id: program.id }
                    }"
                    class="btn btn-xs btn-outline-primary mr-1"
                  >
                    <i class="flaticon-eye"></i>
                    مشاهده
                  </router-link>
                  <router-link
                    v-show="!isStopped(program)"
                    :to="{
                      name: 'company-programs-edit',
                      params: { id: program.id }
                    }"
                    class="btn btn-xs btn-outline-primary mr-1"
                  >
                    <i class="flaticon-edit"></i>
                    ویرایش
                  </router-link>
                  <button
                    class="btn btn-xs btn-outline-danger mr-1"
                    @click="destroy(program.id)"
                  >
                    <i class="flaticon2-trash"></i>
                    حذف
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div
      class="overflow-auto mt-5"
      v-if="companyProgramsPagination.lastPage > 1"
    >
      <b-pagination
        v-model="companyProgramsPagination.currentPage"
        :total-rows="companyProgramsPagination.total"
        :per-page="companyProgramsPagination.perPage"
        aria-controls="my-table"
        @input="updatePrograms()"
      ></b-pagination>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { SET_ACTIONS } from "@/core/services/store/actions.module";
import { FETCH_COMPANY_PROGRAMS } from "@/core/services/store/company/programs.module";
import { DESTROY_PROGRAM } from "@/core/services/store/programs.module";
import { mapGetters } from "vuex";
import Swal from "sweetalert2";

export default {
  name: "companyPrograms",
  data() {
    return {
      loaded: false,
      searchProgram: ""
    };
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: this.currentUserProperty.title ?? "شرکت",
        route: { name: "company-dashboard" }
      },
      { title: "برنامه‌‌ها" }
    ]);
    this.$store.dispatch(SET_ACTIONS, {});

    this.updatePrograms();
  },
  computed: {
    ...mapGetters([
      "currentUserProperty",
      "companyPrograms",
      "companyProgramsPagination",
      "programTypes",
      "programPlans"
    ])
  },
  methods: {
    updatePrograms() {
      this.loaded = false;

      this.$store
        .dispatch(FETCH_COMPANY_PROGRAMS, { name: this.searchProgram })
        .then(() => {
          this.loaded = true;
        })
        .catch(() => {
          this.loaded = true;
        });
    },
    searchPrograms() {
      this.loaded = false;

      this.$store
        .dispatch(FETCH_COMPANY_PROGRAMS, { name: this.searchProgram, page: 1 })
        .then(() => {
          this.loaded = true;
        })
        .catch(() => {
          this.loaded = true;
        });
    },
    isStopped(program) {
      return program.events.length;
    },
    destroy(id) {
      Swal.fire({
        title: "",
        text: "آیا از حذف برنامه‌ اطمینان دارید؟",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "بله",
        confirmButtonColor: "#1e1f22",
        cancelButtonText: "خیر",
        cancelButtonColor: "#ed1c24",
        heightAuto: false
      }).then(result => {
        if (result.isConfirmed) {
          this.$store.dispatch(DESTROY_PROGRAM, id).then(() => {
            this.updatePrograms();
          });
        }
      });
    }
  }
};
</script>
